// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatAlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="nonzero"
      d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
    />
  </svg>
);

export default FormatAlignCenter;
